import React from 'react'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { TeamsWithColours } from './RoundResults'
import ResultsBarChart from './charts/ResultsBarChart'
import { percentage, round, thousandSeparator } from '../model/utils/formatters'
import ChartCard from './components/ChartCard'
import { getYAxisDataV2 } from './charts/yaxis'

interface Props {
  currencyDenomination: string
  teams: TeamsWithColours[]
  npatRoe: ModelAPI.Reporting.NpatAndRoe[]
}

const TopLabel = (val: any): React.FC => (props: any) => {
  const { x, y, width, height, value } = props
  if (value == null) {
    return null
  }
  return <g>
    <text x={x + width / 2} y={(value < 0 ? y + height : y) + (value < 0 ? -10 : value < 200 ? -15 : -5)} fill="#000" textAnchor="middle" font-weight="bold" font-size='0.8rem'>
      {val}
    </text>
  </g>
}

const MiddleLabel = (val: any): React.FC => (props: any) => {
  const { x, y, width, height, value } = props
  if (value == null) {
    return null
  }
  return <g>
    <rect x={x + (width / 2) - 25} y={y + (height / 2) - 15} width={50} height={20} fill="#fff"></rect>
    <text x={x + width / 2} y={y + height / 2} fill="#000" textAnchor="middle" font-weight="bold">
      {val}
    </text>
  </g>
}

const RoundResultsNPATRoe: React.FC<Props> = ({
  currencyDenomination,
  teams,
  npatRoe
}) => {
  const data = npatRoe.map((teamValue) => {
    const team = teams.find(t => t.teamId === teamValue.teamId)
    if (team == null) {
      throw new Error('Team should exist')
    }
    let result: any = {
      name: team.teamName,
      [`team${teamValue.teamId}`]: teamValue.npat,
      key: `team${teamValue.teamId}`,
      colour: team.colour,
      formatter: (val: number, params: any) => {
        if (params?.position === 'top') {
          return thousandSeparator(round(teamValue.npat, 0))
        } else if (params?.position === 'middle') {
          return percentage(teamValue.roe)
        }
        return ''
      },
      topLabel: TopLabel(thousandSeparator(round(teamValue.npat, 0))),
      content: MiddleLabel(percentage(teamValue.roe)),
      hasMiddleLabel: true
    }
    for (const team of teams) {
      if (team.teamId !== teamValue.teamId) {
        result[`team${team.teamId}`] = null
      }
    }
    return result
  })

  const { minValue, maxValue, numberOfTicks } = getYAxisDataV2({
    pastRound1: true,
    min: 0,
    data: [{name: 'fake0', value: 0}].concat(npatRoe.map(np => ({ name: 'dddd', value: np.npat })))
  })

  return (
    <VerticalGroup full center wide>
      <ChartCard
        heading='NPAT &amp; ROE'
        currencyDenomination={currencyDenomination}
      >
        <ResultsBarChart
          data={data}
          teams={teams}
          formatter={(val: number) => thousandSeparator(round(val, 0))}
          minYAxisvalue={minValue}
          maxYAxisvalue={maxValue}
          numberOfTicks={numberOfTicks}
        />
      </ChartCard>
    </VerticalGroup>
  )
}

export default RoundResultsNPATRoe